import { IAppState } from '../../redux';

export function selectIsTermsDurationsAvailable(state: IAppState): boolean {
  return !!state.termsDurations.durations.length;
}
